export const AUTH_PATH = '/auth'
export const WATCHLIST_PATH = '/watchlist'
export const SEARCH_PATH = '/search'
export const MOVIE_DETAILS_PATH = '/movie'
